import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga';
import App from './views/App';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID)

// React 18 createRoot API
const root = createRoot(document.getElementById('root'));
root.render(<App />);
